import { Observable, Subject } from 'rxjs'
import { Injectable } from '@tanbo/vue-di-plugin'

@Injectable()
export class GroupRefreshManage {
  onRefresh: Observable<void>
  private updateGroupEvent = new Subject<void>()

  constructor () {
    this.onRefresh = this.updateGroupEvent.asObservable()
  }

  refreshGroup () {
    this.updateGroupEvent.next()
  }
}
